import { AnyAction } from 'redux';
import {
  FETCH_ROLES,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_PERMISSIONS_LIST,
  FETCH_PERMISSIONS_LIST_SUCCESS,
  FETCH_PERMISSIONS_LIST_FAILURE,
  FETCH_ROLE_PERMISSIONS,
  FETCH_ROLE_PERMISSIONS_SUCCESS,
  FETCH_ROLE_PERMISSIONS_FAILURE,
  FETCH_ROLE_USERS,
  FETCH_ROLE_USERS_SUCCESS,
  FETCH_ROLE_USERS_FAILURE,
  FETCH_PERMISSION_MAPPINGS,
  FETCH_PERMISSION_MAPPINGS_SUCCESS,
  FETCH_PERMISSION_MAPPINGS_FAILURE,
  UPDATE_ROLE_PERMISSIONS,
  UPDATE_ROLE_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_PERMISSIONS_FAILURE,
  UPDATE_ROLE_USERS,
  UPDATE_ROLE_USERS_SUCCESS,
  UPDATE_ROLE_USERS_FAILURE,
  MAP_ROLE_PERMISSION,
  MAP_ROLE_PERMISSION_SUCCESS,
  MAP_ROLE_PERMISSION_FAILURE,
  UNMAP_ROLE_PERMISSION,
  UNMAP_ROLE_PERMISSION_SUCCESS,
  UNMAP_ROLE_PERMISSION_FAILURE,
  MAP_ROLE_USER,
  MAP_ROLE_USER_SUCCESS,
  MAP_ROLE_USER_FAILURE,
  UNMAP_ROLE_USER,
  UNMAP_ROLE_USER_SUCCESS,
  UNMAP_ROLE_USER_FAILURE,
  MAP_ROLE_ADUSER,
  MAP_ROLE_ADUSER_SUCCESS,
  MAP_ROLE_ADUSER_FAILURE,
  UNMAP_ROLE_ADUSER,
  UNMAP_ROLE_ADUSER_SUCCESS,
  UNMAP_ROLE_ADUSER_FAILURE,
  ADD_ROLE,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAILURE,
} from './actions';

export const USER_ROLE_CONFIG_STATE_KEY = 'USER_ROLE_CONFIG_REDUCER';

export type State = {
  roles: any[];
  rolesLoading: boolean;
  permissionsList: any[];
  permissionsLoading: boolean;
  rolePermissions: Record<number, number[]>; // map roleId -> permission Ids
  rolePermissionsLoading: boolean;
  roleUsersLoading: boolean;
  roleUsers: Record<number, any[]>; // map roleId -> user objects
  savingPermissions: boolean;
  savingUsers: boolean;
  savingRole: boolean;
  error?: any;
  mappingSaving?: boolean;
  mappingError?: any;
};

const initialState: State = {
  roles: [],
  rolesLoading: false,
  permissionsList: [],
  permissionsLoading: false,
  rolePermissions: {},
  rolePermissionsLoading: false,
  roleUsersLoading: false,
  roleUsers: {},
  permissionMappings: {},
  permissionMappingsLoading: false,
  savingPermissions: false,
  savingUsers: false,
  savingRole: false,
  error: undefined,
  mappingSaving: false,
  mappingError: undefined,
};

export default function reducer(state = initialState, action: AnyAction): State {
  switch (action.type) {
    case FETCH_ROLES:
      return { ...state, rolesLoading: true, error: undefined };
    case FETCH_ROLES_SUCCESS:
      return { ...state, rolesLoading: false, roles: action.payload || [] };
    case FETCH_ROLES_FAILURE:
      return { ...state, rolesLoading: false, error: action.payload };

    case FETCH_PERMISSIONS_LIST:
      return { ...state, permissionsLoading: true, error: undefined };
    case FETCH_PERMISSIONS_LIST_SUCCESS:
      return { ...state, permissionsLoading: false, permissionsList: action.payload || [] };
    case FETCH_PERMISSIONS_LIST_FAILURE:
      return { ...state, permissionsLoading: false, error: action.payload };

    case FETCH_ROLE_PERMISSIONS:
      return { ...state, rolePermissionsLoading: true, error: undefined };
    case FETCH_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        rolePermissionsLoading: false,
        rolePermissions: {
          ...state.rolePermissions,
          [action.payload.roleId]: (action.payload.items || []).map((p: any) => Number(p.Id)),
        },
      };
    case FETCH_ROLE_PERMISSIONS_FAILURE:
      return { ...state, rolePermissionsLoading: false, error: action.payload };

    case FETCH_ROLE_USERS:
      return { ...state, roleUsersLoading: true, error: undefined };
    case FETCH_ROLE_USERS_SUCCESS:
      return {
        ...state,
        roleUsersLoading: false,
        roleUsers: {
          ...state.roleUsers,
          [action.payload.roleId]: action.payload.users || [],
        },
      };
    case FETCH_ROLE_USERS_FAILURE:
      return { ...state, roleUsersLoading: false, error: action.payload };

    case FETCH_PERMISSION_MAPPINGS:
      return { ...state, permissionMappingsLoading: true, error: undefined };
    case FETCH_PERMISSION_MAPPINGS_SUCCESS:
      return {
        ...state,
        permissionMappingsLoading: false,
        permissionMappings: {
          ...state.permissionMappings,
          [action.payload.permissionId]: action.payload.items || { Roles: [], Users: [] },
        },
      };
    case FETCH_PERMISSION_MAPPINGS_FAILURE:
      return { ...state, permissionMappingsLoading: false, error: action.payload };

    case UPDATE_ROLE_PERMISSIONS:
      return { ...state, savingPermissions: true, error: undefined };
    case UPDATE_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        savingPermissions: false,
        rolePermissions: {
          ...state.rolePermissions,
          [action.payload.roleId]: (action.payload.items || []).map((p: any) => Number(p.Id)),
        },
      };
    case UPDATE_ROLE_PERMISSIONS_FAILURE:
      return { ...state, savingPermissions: false, error: action.payload };

    case UPDATE_ROLE_USERS:
      return { ...state, savingUsers: true, error: undefined };
    case UPDATE_ROLE_USERS_SUCCESS:
      return {
        ...state,
        savingUsers: false,
        roleUsers: {
          ...state.roleUsers,
          [action.payload.roleId]: action.payload.users || [],
        },
      };
    case UPDATE_ROLE_USERS_FAILURE:
      return { ...state, savingUsers: false, error: action.payload };

    case MAP_ROLE_PERMISSION:
    case UNMAP_ROLE_PERMISSION:
    case MAP_ROLE_USER:
    case UNMAP_ROLE_USER:
    case MAP_ROLE_ADUSER:
    case UNMAP_ROLE_ADUSER:
      return { ...state, mappingSaving: true, mappingError: undefined };

    case MAP_ROLE_PERMISSION_SUCCESS:
    case UNMAP_ROLE_PERMISSION_SUCCESS:
    case MAP_ROLE_USER_SUCCESS:
    case UNMAP_ROLE_USER_SUCCESS:
    case MAP_ROLE_ADUSER_SUCCESS:
    case UNMAP_ROLE_ADUSER_SUCCESS:
      return { ...state, mappingSaving: false, mappingError: undefined };
    case MAP_ROLE_PERMISSION_FAILURE:
    case UNMAP_ROLE_PERMISSION_FAILURE:
    case MAP_ROLE_USER_FAILURE:
    case UNMAP_ROLE_USER_FAILURE:
    case MAP_ROLE_ADUSER_FAILURE:
    case UNMAP_ROLE_ADUSER_FAILURE:
      return { ...state, mappingSaving: false, mappingError: action.payload };

    case ADD_ROLE:
      return { ...state, savingRole: true, error: undefined };
    case ADD_ROLE_SUCCESS:
      return { ...state, savingRole: false, roles: [...state.roles, action.payload] };
    case ADD_ROLE_FAILURE:
      return { ...state, savingRole: false, error: action.payload };

    default:
      return state;
  }
}
